module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block height"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('ul', {
    staticClass: "listing list"
  }, _vm._l((_vm.dekkingArray), function(dekking) {
    return _c('li', {
      key: dekking
    }, [_vm._v(_vm._s(dekking))])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('span', [_vm._v("Dekking")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007b4ebd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/polisdetails/dekking.vue
// module id = 53
// module chunks = 0